import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { palette } from 'theme';
import Slide from '@material-ui/core/Slide';

import NavLink from 'views/Layout/Header/elements/NavLink';

const AnnouncementWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-basis: 66%;
  height: 32px;
`;

const AnnouncementNavLink = styled(NavLink)`
  background-color: ${palette.grey[900]};
  width: 100%;
  position: absolute;
  padding: 0;
  margin: 0;
  align-items: flex-start;
  &:hover {
    background-color: ${palette.grey[900]};
  }
  span {
    font-weight: 500;
  }
  .label {
    font-weight: 400;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const NavAnnouncements = ({ items = [] }) => {
  const [current, setCurrent] = useState(0);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    if (items.length > 0) {
      const next = (current + 1) % items.length;
      const id = setTimeout(() => setCurrent(next), 7000);
      if (hovered) {
        clearTimeout(id);
      }
      return () => clearTimeout(id);
    }
  }, [current, hovered, items.length]);

  return (
    <>
      <AnnouncementWrapper
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {(items || []).map((announcement, idx) => (
          <Slide
            in={current === idx}
            timeout={{ enter: 240, exit: 0 }}
            key={idx}
          >
            <AnnouncementNavLink
              {...announcement}
              badgePosition="left"
              key={idx}
            />
          </Slide>
        ))}
      </AnnouncementWrapper>
    </>
  );
};

export default NavAnnouncements;
